const routes = [
    {
        path: "/housing/beds",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingbed_index"
        }
    }
]

export default routes;
